import { invalid_type } from '../asserts/utils_asserts';

export class UTILS__number {
  static is_safe(value: unknown) {
    return typeof value === 'number' && !isNaN(value) && isFinite(value);
  }
}

export function format_compact_number(value: number | string): string {
  let value_number = typeof value === 'string' ? parseFloat(value) : value;

  if (isNaN(value_number)) return 'NaN';

  if (value_number < 1000) return value_number.toString();

  const suffixes = ['', 'K', 'M', 'B', 'T', 'Q', 'Qi', 'Sx', 'Sp'];

  let exponent = Math.floor(Math.log10(value_number) / 3);

  let value_short = value_number / Math.pow(1000, exponent);

  let value_formatted = parseFloat(value_short.toFixed(1));

  return `${value_formatted}${suffixes[exponent] || ''}`;
}

export function format_number_with_spaces(value: number | string): string {
  let valueNumber = typeof value === 'string' ? parseFloat(value) : value;

  if (isNaN(valueNumber)) return 'NaN';

  return valueNumber.toLocaleString('uk-UA');
}

export function number_round_fix(value: number, precision: number = 1): number {
  return Number(value.toFixed(precision));
}

export function number_round(value: number, precision: number = 1): number {
  const factor = Math.pow(10, precision);

  return Math.round(value * factor) / factor;
}

export function string_to_number(value: any): number {
  let out = 0;

  if (typeof value === 'string') {
    out = parseFloat(value.trim());
  } else if (typeof value === 'number') {
    out = value;
  } else {
    invalid_type(typeof value);
  }

  return out;
}

export function get_digits_count(value: number) {
  return value == 0 ? 1 : Math.floor(Math.log10(value)) + 1;
}

export function number_average(array: number[]): number {
  if (array.length === 0) return 0; // Avoid division by zero

  return array.reduce((sum, num) => sum + num, 0) / array.length;
}
